module.exports = __webpack_public_path__ + "img/lock.89f674b3.svg";